import script from "./VideoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoDialog.vue?vue&type=style&index=0&id=93096a60&lang=scss&scoped=true"
import "./VideoDialog.vue?vue&type=style&index=1&id=93096a60&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93096a60"]])

export default __exports__